export const generateMinimize = (data) => {
  const backgroundUrl = data?.background.url || ''
  const minimizeTitle = data?.text?.content || ''
  const titleStyle = data?.text?.style || {}

  const html = `
  <div id="kariba_default_code_minimize" class="hide-class"
    style="background: url(${backgroundUrl || ''}) no-repeat;
      background-size: cover;
      background-position: center;">
      <span
      style="font-family: ${titleStyle.fontFamily || 'Inter'}; 
        color: ${titleStyle.color || '#FA541C'};
        font-size: ${titleStyle.fontSize || 14}px;
        font-weight: ${titleStyle.fontStyle || 'bold'};"
      >${minimizeTitle}</span>
    </div>
  </div>`

  return html
}
